import { shell, Eyebrow, Title, CTA } from "../components/CommonComponents";

const Eligibility = ({ course }) => {
  return (
    <section id="eligibility" className="relative scroll-mt-6 bg-white py-20 sm:py-24 lg:py-28">
      <span className="pointer-events-none absolute right-[4%] top-4 select-none font-serif text-[110px] leading-none text-[#071A2F]/[.025] sm:text-[170px]">

      </span>
      <div
        className={`${shell} grid overflow-hidden rounded-[8px_42px_8px_8px] bg-[#EEF4F8] lg:grid-cols-[.72fr_1.28fr]`}
      >
        <div className="relative min-h-[430px]">
          <img
            src={course.images.studentLife}
            alt="Student community"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/85 to-transparent" />
          <span className="absolute bottom-7 left-7 text-sm font-bold uppercase tracking-[.14em] text-[#D5AD57]">
            Admission checkpoint
          </span>
        </div>
        <div className="p-8 sm:p-10 lg:p-12">
          <Eyebrow>Eligibility criteria</Eyebrow>
          <Title>Eligibility Criteria for {course.shortName}</Title>
          <p className="mt-7 text-lg leading-9 text-[#65717D]">
            {course.eligibility}
          </p>
          <div className="mt-8">
            <CTA>Check your eligibility</CTA>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Eligibility;
